"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainEvent = exports.DISCOVERED_EVENTS = void 0;
const EventBase_1 = require("../EventBase");
const EventSchema_1 = require("./EventSchema");
exports.DISCOVERED_EVENTS = new Map();
function DomainEvent(parameters) {
    return (target) => {
        if (!(target.prototype instanceof EventBase_1.DomainEventBase)) {
            throw new Error(`Can not apply @${DomainEvent.name} decorator on ${target.name} : the class must extends ${EventBase_1.DomainEventBase.name}`);
        }
        const propertiesSchema = EventSchema_1.getEventPropertiesSchema(target);
        const schema = {
            version: parameters.version,
            eventName: parameters.name.toLowerCase(),
            namespace: parameters.namespace,
            properties: propertiesSchema !== null && propertiesSchema !== void 0 ? propertiesSchema : [],
        };
        let eventKey = `${schema.eventName}>${schema.version}`;
        // add the namespace if defined
        if (schema.namespace) {
            eventKey = `${schema.namespace}>${eventKey}`;
        }
        else {
            delete schema.namespace;
        }
        const alreadyRegisteredOnClass = exports.DISCOVERED_EVENTS.get(eventKey);
        if (alreadyRegisteredOnClass) {
            const registeredClassMeta = EventSchema_1.getEventSchema(alreadyRegisteredOnClass);
            if (!registeredClassMeta) {
                throw new Error(`Unexpected class ${alreadyRegisteredOnClass.name} in registered domain events`);
            }
            if (registeredClassMeta.namespace === schema.namespace) {
                throw new Error(`Can not apply @${DomainEvent.name} decorator on ${target.name} : event ${schema.eventName} already defined in version ${schema.version} on class ${alreadyRegisteredOnClass.name}`);
            }
        }
        EventSchema_1.setEventSchema(target, schema);
        exports.DISCOVERED_EVENTS.set(eventKey, target);
    };
}
exports.DomainEvent = DomainEvent;
//# sourceMappingURL=EventDecorator.js.map